import React, { Component } from 'react';
import { Grid, Switch, List, ListItem, ListItemIcon, IconButton,TextField  } from '@material-ui/core';
import { Delete, AddCircle  } from '@material-ui/icons';
import TranslationEditor from './translationEditor';


class AppSettingsMeetingPolicy extends Component {

  meetingPolicy = () => {
    const settings = this.props.settings;
    const policyDisabled = !settings.enabled || !settings.policy.enabled;

    const meetingPolicyToggle = <Switch disabled={!settings.enabled} checked={settings.policy.enabled} onChange={this.props.handleChange} color="primary" name="settings.policy.enabled" />

    const addPolicy = () => {
      settings.policy.policy.push("");
      this.props.updatePolicy(settings.policy)
    }
    const deletePolicy = (removeIndex) => {
      settings.policy.policy = settings.policy.policy.filter((i, index) => index !== removeIndex);

      // Handle potential translations
      if(settings.policy.i18){
        // First remove the potentially existing translation
        if(settings.policy.i18["policy." + removeIndex])
          delete settings.policy.i18["policy." + removeIndex];

        // Loop through the policy translations and update the indexes accordingly:
        Object.keys(settings.policy.i18).filter(k => k.startsWith("policy.")).forEach((key) => {
          const [variable, index] = key.split(".");
          if(index > removeIndex) {
            settings.policy.i18[variable + "." + (index - 1)] = settings.policy.i18[key];
            delete settings.policy.i18[key];
          }
        });
      }
      this.props.updatePolicy(settings.policy)
    }
  
    const getTranslation = (name) => {
      if(settings.policy.i18 && settings.policy.i18[name])
        return settings.policy.i18[name];
    }
    const updateTranslation = (i18, name) => {
      if(i18) {
        if(!settings.policy.i18) settings.policy.i18 = {};
        settings.policy.i18[name] = i18;
      } else {
        delete settings.policy.i18[name];
      }
      this.props.updatePolicy(settings.policy);
    }
    const meetingPolicy =
     <Grid item xs={12}>
      { this.props.createHeader("Meeting Policy Enabled:", "These settings control how the meeting policy is shown on the calendar.", meetingPolicyToggle) }
      <Grid container spacing={1} className="ml-3">
        <Grid item xs={5}>
          <Grid container spacing={2} direction="column" >
            { this.props.createHeader("Policy Header", "Header for your meeting policy on the event. i.e. Flowtrace Meeting Policy")}
            <Grid item >
              <Grid container spacing={2} direction="row"  alignItems="center" >
                <Grid item xs={10}>
                  <TextField id={"policy-header"} disabled={policyDisabled} name={"settings.policy.header"} onChange={this.props.updateValue} value={settings.policy.header} fullWidth variant="outlined" className="mr-2" />
                </Grid>
                <Grid item xs={2}>
                  <TranslationEditor id={"policy-header-translation"} disabled={policyDisabled} name={"header"} text={settings.policy.header} i18={getTranslation("header")} updateTranslation={(i18) => updateTranslation(i18, "header")} />
                </Grid>
              </Grid>
            </Grid>
            { this.props.createHeader("Policy items", "You can add any number of bullet points to your meeting policy. We recommend using short sentences and linking the the policy to your meeting policy document/article.")}
            <Grid item >
              <List dense={true}>
                {
                  settings.policy.policy.map((i, index) =>
                    <ListItem key={"policy-list-item-"+index}>
                      <ListItemIcon id={"policy-list-item-icon"+index}>
                        <IconButton disabled={policyDisabled} id={"policy-list-item-icon-button-"+index} onClick={() => deletePolicy(index)} aria-label="Delete this item">
                          <Delete id={"policy-list-item-delete-"+index}/>
                        </IconButton>
                      </ListItemIcon>
                      <TextField disabled={policyDisabled} id={"policy-item-text-"+index} value={i} onChange={this.props.updateValue} name={"settings.policy.policy|" + index} fullWidth variant="outlined" className="mr-2" />
                      <TranslationEditor id={"policy-list-item-editor-"+index} disabled={policyDisabled} name={"policy." + index} text={i} i18={getTranslation("policy." + index)} updateTranslation={(i18) => updateTranslation(i18, "policy." + index)} />
                    </ListItem>
                  )
                }
                <ListItem key={"policy-list-item-add"}>
                  <ListItemIcon>
                    <IconButton disabled={policyDisabled} onClick={() => addPolicy()} aria-label="Add new item">
                      <AddCircle  />
                    </IconButton>
                  </ListItemIcon>
                </ListItem>
              </List>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1} direction="row" alignItems="center">
                { this.props.createHeader("Policy Link Text", "Add here the text to link to your policy URL.")}
                <Grid item xs={10}>
                  <TextField id={"policy-url-text"} disabled={policyDisabled} name={"settings.policy.url_text"} onChange={this.props.updateValue} value={settings.policy.url_text} fullWidth variant="outlined" />
                </Grid>
                <Grid item xs={2}>
                  <TranslationEditor id={"policy-link-translation"} disabled={policyDisabled} name={"url_text"} text={settings.policy.url_text} i18={getTranslation("url_text")} updateTranslation={(i18) => updateTranslation(i18, "url_text")} />
                </Grid>
                { this.props.createHeader("URL to Policy", "Add here your company's meeting policy URL/link.")}
                <Grid item xs={12}>
                  <TextField id={"policy-url"} disabled={policyDisabled} name={"settings.policy.url"} onChange={this.props.updateValue} value={settings.policy.url} fullWidth variant="outlined" />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>;
    return meetingPolicy;
  }
  
  render() {
    if (this.props.loading)
      return this.props.loading();

    return this.meetingPolicy();

  }
}
export default AppSettingsMeetingPolicy;
